import { render, staticRenderFns } from "./EzCareInformation.vue?vue&type=template&id=754706e2&scoped=true"
import script from "./EzCareInformation.vue?vue&type=script&lang=js"
export * from "./EzCareInformation.vue?vue&type=script&lang=js"
import style0 from "./EzCareInformation.vue?vue&type=style&index=0&id=754706e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754706e2",
  null
  
)

export default component.exports